module.exports = __webpack_public_path__ + "static/media/store2.e4a360e4.jpg";